import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { createContext, useContext } from 'react';
import styled from '@emotion/styled';
import { getStyle } from './utils.es.js';
import { Position } from '@teko-builder/types/pb';
import './InputNumber-7d93e963.js';
import { Link } from './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import { g as getIconCompoment } from './common-dbaafe9f.js';

const ListItemContext = createContext({});

const StyledContent = styled.div(({ commonStyle, contentStyle, }) => `
    ${getStyle(contentStyle)}
    ${getStyle(commonStyle)}
  `);
const ListItemContentV2 = React.forwardRef((props, ref) => {
    const { text, children } = props, rest = __rest(props, ["text", "children"]);
    const { contentStyle } = useContext(ListItemContext);
    if (!!children) {
        return (jsx(StyledContent, Object.assign({ ref: ref }, rest, { contentStyle: contentStyle }, { children: children })));
    }
    return (jsx(StyledContent, Object.assign({ ref: ref }, rest, { contentStyle: contentStyle, dangerouslySetInnerHTML: { __html: text } })));
});
ListItemContentV2.displayName = 'ListItemContentV2';

const StyledIcon = styled.div(({ commonStyle, iconStyle }) => `
  display: flex;
  ${getStyle(iconStyle)}
  ${getStyle(commonStyle)}
`);
const ListItemIconV2 = React.forwardRef((props, ref) => {
    const { commonStyle, event, icon, link, position } = props;
    const { iconConfig, iconStyle } = useContext(ListItemContext);
    const GlobalIcon = getIconCompoment(iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon);
    const IconComponent = getIconCompoment(icon);
    return (jsxs(Fragment, { children: [position === Position.behind && (jsx("div", { style: { width: iconConfig.spacing } })), jsx(StyledIcon, Object.assign({ ref: ref, commonStyle: commonStyle, iconStyle: iconStyle }, { children: jsx(Link, Object.assign({}, link, event, { children: IconComponent || GlobalIcon })) })), position === Position.front && (jsx("div", { style: { width: iconConfig.spacing } }))] }));
});
ListItemIconV2.displayName = 'ListItemIconV2';

const Wrapper = styled.div(({ commonStyle }) => `
    display: flex;
    ${getStyle(commonStyle)}
`);
const ListItemV2 = React.forwardRef((_a, ref) => {
    var { children, commonStyle } = _a, rest = __rest(_a, ["children", "commonStyle"]);
    const { contentStyle, iconConfig, iconStyle, content } = rest;
    return (jsx(ListItemContext.Provider, Object.assign({ value: {
            contentStyle,
            iconConfig,
            iconStyle,
            content,
        } }, { children: jsx(Wrapper, Object.assign({ ref: ref, commonStyle: commonStyle }, rest, { children: children })) })));
});
ListItemV2.displayName = 'ListItemV2';

export { ListItemContentV2 as L, StyledContent as S, ListItemIconV2 as a, ListItemV2 as b };
